import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname, state } = useLocation();

    useEffect(() => {
        if (state?.targetId) {
            const element = document.getElementById(state.targetId);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: "smooth" });
                }, 100);
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, state]);

    return null;
};

export default ScrollToTop;
